var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCloseCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2939 9.60601C9.96589 9.27797 9.43404 9.27797 9.106 9.60601C8.77796 9.93405 8.77796 10.4659 9.106 10.794L11.312 13L9.10602 15.206C8.77798 15.5341 8.77798 16.0659 9.10602 16.394C9.43406 16.722 9.96592 16.722 10.294 16.394L12.5 14.1879L14.706 16.3939C15.034 16.722 15.5659 16.722 15.8939 16.3939C16.222 16.0659 16.222 15.534 15.8939 15.206L13.6879 13L15.8939 10.794C16.222 10.4659 16.222 9.93408 15.8939 9.60604C15.5659 9.27799 15.034 9.27799 14.706 9.60604L12.5 11.8121L10.2939 9.60601Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0.96C5.85049 0.96 0.46 6.35049 0.46 13C0.46 19.6495 5.85049 25.04 12.5 25.04C19.1495 25.04 24.54 19.6495 24.54 13C24.54 6.35049 19.1495 0.96 12.5 0.96ZM2.14 13C2.14 7.27833 6.77833 2.64 12.5 2.64C18.2217 2.64 22.86 7.27833 22.86 13C22.86 18.7217 18.2217 23.36 12.5 23.36C6.77833 23.36 2.14 18.7217 2.14 13Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CloseCircle.e6bedbfa.svg";
export { ForwardRef as ReactComponent };